// src/services/companies.ts
import { supabase } from "../lib/supabase";
import type { Company, ID } from "../types/domain";

export async function listCompanies() {
  const { data, error } = await supabase
    .from("companies")
    .select("*")
    .order("name", { ascending: true });

  return { data: (data as Company[]) ?? [], error };
}

export async function createCompany(payload: { name: string }) {
  const { data, error } = await supabase
    .from("companies")
    .insert({ name: payload.name })
    .select()
    .single();
  return { data: data as Company | null, error };
}

export async function updateCompany(id: ID, patch: Partial<Company>) {
  const { data, error } = await supabase
    .from("companies")
    .update({ name: patch.name })
    .eq("id", id)
    .select()
    .single();
  return { data: data as Company | null, error };
}

export async function deleteCompany(id: ID) {
  const { error } = await supabase.from("companies").delete().eq("id", id);
  return { error };
}
